// Webflow minimal maintenance (platform updates, minor fixes, monitoring)
export const WEBFLOW_ANNUAL_MAINTENANCE = 5000;

// Azai Studios rates
export const AZAI_HOURLY_RATE = 250;
export const AZAI_HOURS_PER_STATIC_PAGE = 4;
export const AZAI_HOURS_PER_DYNAMIC_PAGE = 8;

// Redesign additional work
export const REDESIGN_BASE_HOURS = 80;
export const REDESIGN_HOURS_PER_PAGE = 3;
export const REDESIGN_DEV_MULTIPLIER = 1.4;

// SEO audit base hours
export const SEO_BASE_HOURS = 12;
export const SEO_HOURS_PER_PAGE = 0.25;

// Competitor rates
export const OTHER_AGENCY_HOURLY_RATE = 185;
export const OTHER_AGENCY_BUILD_MULTIPLIER = 2.5;
export const OTHER_AGENCY_SEO_MULTIPLIER = 1.5;
export const FREELANCER_HOURLY_RATE = 75;
export const FREELANCER_BUILD_MULTIPLIER = 4;
export const FREELANCER_SEO_MULTIPLIER = 2.0;

// Developer hourly rates for CMS maintenance by company size
// Reflects market rates: startups use freelancers/contractors, enterprises pay premium
export const DEV_HOURLY_RATE_BY_SIZE = {
  startup: 175,         // Freelancer/contractor rates
  midmarket: 225,       // Agency/senior contractor rates
  enterprise: 300,      // Senior dev / consulting rates
  largeEnterprise: 350, // Enterprise consulting rates
};
